<app-centre-small-opener>
    <h2 mat-dialog-title dialogTitle class="title mar-b-5">View Minutes</h2>
    <div mat-dialog-content contentContainer class="row" style="overflow: hidden;">
      <div class="col-lg-12 col-sm-12" style="padding: 0px;">
        <mat-form-field appearance="fill">
          <!-- <mat-label>MOM</mat-label> -->
          <mat-select [(ngModel)]="selectedValue" name="momSelect"   (selectionChange) = "viewMomPdf()">
            <ng-container *ngFor="let momLst of momList">
              <mat-option [value]="momLst.pkMomDetailId" (click)="setCurrentMomInfo(momLst)">
                {{momLst.momTitle}}
              </mat-option>
          </ng-container>
          </mat-select>
        </mat-form-field>
      </div>  
      <div class="loading-indicator">
          <mat-progress-spinner mode="indeterminate"  *ngIf="showLoading" bdColor="rgba(51,51,51,0.8)"></mat-progress-spinner>
        </div>
        <!-- <div class="col-lg-12 col-sm-12" style="padding: 0px;">
              <iframe id="viewMinutes" src="" style="height: 58vh;" type="application/pdf" width="100%" height="100vh"></iframe>
        </div> -->
    </div>
  </app-centre-small-opener>